import { Users, Lightbulb, Vote, Sparkles } from "lucide-react";

const features = [
  {
    icon: Users,
    title: "Gruppen erstellen",
    text: "Erstelle Gruppen für Freunde, Familie oder deinen Verein – alles Wichtige an einem Ort.",
    testid: "feature-gruppen",
  },
  {
    icon: Lightbulb,
    title: "Ideen & Vorschläge",
    text: "Sammelt Ideen für Ausflüge, Essen, Events und mehr – jeder darf Vorschläge einbringen.",
    testid: "feature-ideen",
  },
  {
    icon: Vote,
    title: "Gemeinsam abstimmen",
    text: "Stimmt gemeinsam ab und findet in Sekunden heraus, was alle wollen – ohne Diskussionschaos.",
    testid: "feature-abstimmen",
  },
  {
    icon: Sparkles,
    title: "Match & loslegen",
    text: "Sobald alle zustimmen, heißt es nur noch: Termin festmachen und einfach etwas unternehmen.",
    testid: "feature-match",
  },
];

export const Features = () => (
  <section id="funktionen" className="scroll-mt-20 bg-white py-20 lg:py-28">
    <div className="mx-auto max-w-6xl px-5">
      <div className="max-w-2xl">
        <p className="text-xs font-extrabold uppercase tracking-widest text-teal-600">
          Die wichtigsten Funktionen
        </p>
        <h2 className="font-display mt-3 text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl">
          Schluss mit „Was machen wir?" – Wokivo entscheidet mit euch.
        </h2>
      </div>
      <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {features.map((f) => (
          <div
            key={f.title}
            data-testid={f.testid}
            className="group rounded-3xl border border-teal-100 bg-teal-50/40 p-7 transition-[transform,box-shadow,background-color] duration-300 hover:-translate-y-1.5 hover:bg-white hover:shadow-xl hover:shadow-teal-500/10"
          >
            <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-teal-500 text-white shadow-lg shadow-teal-500/25 transition-transform duration-300 group-hover:scale-110">
              <f.icon className="h-6 w-6" strokeWidth={2.2} />
            </div>
            <h3 className="font-display mt-5 text-lg font-bold text-slate-900">
              {f.title}
            </h3>
            <p className="mt-2 text-sm leading-relaxed text-slate-600">
              {f.text}
            </p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
